import React, { useEffect, useState } from 'react'
import { Box, Button, Collapse, Grid, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDispatch } from 'react-redux'
import { Modal } from '../../../../components'
import { requestModer } from '../../../../api'
import { modalsAction } from '../../../../store/modals'

export const ModerRequestModal: React.FC<{
  id: number
  show: boolean
  confirm: boolean
  updateInfo(): void
  onClose: () => void
}> = ({ id = 0, show = false, confirm = true, updateInfo, onClose = () => {} }): JSX.Element => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const [collapse, setCollapse] = useState<boolean>(true)

  const onConfirm = (type: string) => {
    requestModer({ requestId: id, status: type })
      .then(({ status = 0, message: messages }) => {
        if (status === 1) {
          dispatch(
            modalsAction.alert({
              message: { success: [`${messages}`] },
              onClose: () => {
                updateInfo()
                onCloseModal()
              },
            })
          )
        } else {
          dispatch(
            modalsAction.alert({
              message: { error: [`${messages}`] },
              onClose: () => {
                updateInfo()
                onCloseModal()
              },
            })
          )
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          dispatch(
            modalsAction.alert({
              message: err.response.data.message.error,
              onClose: () => {
                updateInfo()
                onCloseModal()
              },
            })
          )
        }
      })
  }

  const onCloseModal = () => {
    onClose()
    setCollapse(false)
  }

  useEffect(() => {
    if (!collapse) {
      setTimeout(() => setCollapse(true), 200)
    }
  }, [collapse])

  return (
    <Modal
      open={show}
      maxWidth="sm"
      title={confirm ? 'Принятие заявки' : 'Отклонение заявки'}
      onClose={onCloseModal}
      className={classes.modal}
    >
      <Collapse in={collapse}>
        <Box mt={3}>
          <Box className={classes.text}>
            {confirm ? (
              <>
                После подтверждения заявки ее отклонение будет невозможно.
                <br />
                <Box mt={2}>Подтвердить заявку?</Box>
              </>
            ) : (
              <>
                После отклонения заявки ее подтверждение будет невозможно.
                <br />
                <Box mt={2}>Отклонить заявку?</Box>
              </>
            )}
          </Box>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                className={classes.btn}
                onClick={() => onConfirm(confirm ? 'CONFIRM' : 'REJECT')}
              >
                {confirm ? <>Подтвердить</> : <>Отклонить</>}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="secondary" className={classes.btnReject} onClick={onCloseModal}>
                Закрыть
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </Modal>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  modal: {
    // '& .MuiDialog-paper': {
    //   borderRadius: '0px!important',
    //   border: '1px solid #6C6C6C!important',
    // },
    '& .MuiDialogTitle-root': {
      fontSize: '26px!important',
      paddingLeft: '60px!important',
      paddingRight: '60px!important',
      [down('sm')]: {
        fontSize: '24px!important',
        paddingLeft: '40px!important',
        paddingRight: '40px!important',
      },
    },
    '& .MuiFormControlLabel-root .MuiTypography-root': {
      fontSize: '15px!important',
      fontWeight: '600!important',
      color: `${palette.text.secondary}!important`,
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    minWidth: '180px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
      minWidth: '170px!important',
    },
    [down('sm')]: {
      fontSize: '13px!important',
      padding: '10px 12px!important',
      minHeight: '25px!important',
      minWidth: '130px!important',
    },
  },
  btnReject: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    color: `${palette.primary.dark}!important`,
    backgroundColor: '#6C6C6C!important',
    minWidth: '180px!important',
    '&:hover': {
      color: `${palette.text.primary}!important`,
      backgroundColor: `#5b5b5b!important`,
    },
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
      minWidth: '170px!important',
    },
    [down('sm')]: {
      fontSize: '13px!important',
      padding: '10px 12px!important',
      minHeight: '25px!important',
      minWidth: '130px!important',
    },
  },
  text: {
    fontSize: 17,
    lineHeight: 1.4,
    textAlign: 'center',
    padding: '0 30px 40px',
    [down('md')]: {
      fontSize: 17,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
}))
